<template>
  <!--Testimonial start-->
  <section class="testimonial" id="testimonial" ref="testimonialPosition">
    <div class="animation-circle-inverse"><i></i><i></i><i></i></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="testimonil-box testimonial-slider">
            <swiper
              class="testimonial-slider mySwiper"
              :loop="true"
              :pagination="{
                dynamicBullets: true,
                clickable: true,
              }"
              :modules="modules"
            >
              <swiper-slide v-for="(person, index) in people" :key="index">
                <div class="item testi-profile">
                  <div class="media">
                    <div class="animated-circle">
                      <img
                        class="img-fluid align-self-center"
                        :src="person.imageUrl"
                        alt="1"
                      />
                    </div>
                    <div class="media-body">
                      <h3 class="mt-0 sub-title">
                        {{ person.name }}
                      </h3>
                      <p>
                        {{ person.description }}
                      </p>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--Testimonial end -->
</template>
<script>
import SwiperCore, {
  Navigation,
  Parallax,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
SwiperCore.use(Navigation);

export default {
  name: "Testimonial",
  components: {
    Swiper,
    SwiperSlide,
    // swiperSlide,
    // swiper,
    // VueSlickCarousel,
  },
  mounted() {
    let payload = {
      position: this.$refs["testimonialPosition"].offsetTop,
      name: "testimonialPosition",
    };
    this.$emit("windowPosition", payload);
  },
  data() {
    return {
      // modules: [Navigation, Pagination, Scrollbar, A11y],
      modules: [Pagination],
      people: [
        {
          name: "Mark Jecno  (Designer & Developer)",
          description:
            "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.",
          imageUrl: require("../assets/images/1.png"),
        },
        {
          name: "Mark Jecno  (Designer & Devloper)",
          description:
            "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.",
          imageUrl: require("../assets/images/1.png"),
        },
        {
          name: "Mark Jecno  (Designer & Devloper)",
          description:
            "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.",
          imageUrl: require("../assets/images/1.png"),
        },
      ],
    };
  },
};
</script>
